import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const roleApi = createApi({
  reducerPath: "roleApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Roles"],
  endpoints: (builder) => ({
    getRoles: builder.query({
      providesTags: ["Roles"],
      query: (params = {}) => ({
        url: "/role",
        params, // page optional
      }),
    }),
    createRole: builder.mutation({
      query: (payload) => ({
        url: "/role",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Roles"],
    }),
    updateRole: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/role/${id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Roles"],
    }),
  }),
});

export const {
  useGetRolesQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
} = roleApi;
